module.exports = __webpack_public_path__ + "img/kerstin-roth.f438ee8c.jpg";